<template>
    <SmallHeaderBarPage/>
    <div class="static-header">
        <h1 class="static-header-title">{{ $store.state.pageTitle }}</h1>
        <div v-html="getSVG('arrowLeft')" class="static-header-back" @click="$router.push('/')"/>
    </div>
</template>

<script>
import SmallHeaderBarPage from "@/components/static/SmallHeaderBarPage.vue";

export default {
    components: {SmallHeaderBarPage}
}
</script>
